// @flow
import React from 'react'
import Header from '../shared/Header'
import Avatar from './Avatar'
import UserSettingsForm from './UserSettingsForm'

class UserEditContainer extends React.Component<{model: Object}> {
  render () {
    return (
      <div>
        <Header pageTitle='User Settings' />
        <div className='wrapper-content'>
          <Avatar avatarUrl={this.props.model.get('avatar_url')} />
          <UserSettingsForm model={this.props.model} />
        </div>
      </div>
    )
  }
}

export default UserEditContainer
window.Components.UserEditContainer = React.createFactory(UserEditContainer)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/UserEditContainer.js